import * as Constants from '../utilities/constants/Constants';
import {
  isSignageSuiteProduct,
  isMultiCanvas
} from '../utilities/HelperFunctions/HelperFunctions';
import { isPosterCategory } from '../redux/fabricCanvasActionHelpers';
import { checkIfCanvasApp } from '../redux/homeActions';

export const shouldShowResizeField = () => (dispatch, getState) => {
  const webLink = getState().modal.envData.wallart_lite_web_link;
  return (
    !isSignageSuiteProduct() &&
    (!webLink || (webLink && getState().modal.storeData.supportsRoomSize))
  );
};

export const shouldShowOrientationField = () => dispatch => {
  if (dispatch(isPosterCategory())) {
    return true;
  }
  return false;
};

export const shouldShowMeasurementField = () => () => true;

export const shouldShowBackgroundContrastField = () => dispatch => {
  if (dispatch(isPosterCategory())) {
    return true;
  }
  return false;
};

export const shouldShowLanguageField = () => () => true;

export const shouldShowPixelationWarningField = () => (dispatch, getState) => {
  if (getState().modal.envData.category === Constants.GIFTWRAPS_CATEGORY) {
    return false;
  }
  return true;
};

export const shouldShowRowColumnField = () => dispatch =>
  dispatch(checkIfCanvasApp()) && dispatch(isMultiCanvas());

export const shouldShowWallSizeField = () => dispatch =>
  dispatch(checkIfCanvasApp());
